import { requestApi } from '@app/api';
import { withUpload } from '@app/api/paths';

// eslint-disable-next-line import/prefer-default-export
export function uploadDocumentImage({ base64 }: { base64: string }) {
  return requestApi<{
    fileId: string;
    otp: string;
  }>({
    url: withUpload('/documents/images/upload'),
    method: 'POST',
    credentials: true,
    data: {
      base64,
    },
  }).then((response) => response.data);
}
